<script setup lang="ts">
const runtimeConfig = useRuntimeConfig()
const store = useIndexStore()
const { path } = useRoute()
await store.init({ url: path })
const { recommended1, recommended2, recommended3, html } = storeToRefs(store)
const mobile = ref(true)
let media = ref()
const listener = (e) => {
  mobile.value = !e.matches
}
onBeforeMount(() => {
  media.value = matchMedia('(min-width: 768px)')
  mobile.value = !media.value.matches
  media.value.addEventListener('change', listener)
})
onBeforeUnmount(() => {
  media.value.removeEventListener('change', listener)
})
useHead({
  titleTemplate: 'Prezenty pełne adrenaliny – Twoja podróż z Go-Racing w świat motoryzacji',
  meta: [
    { name: 'description', content: 'Go-Racing, Wyjątkowe prezenty dla niego i dla niej – od ekscytujących przejażdżek bolidem F1, przez jazdę super autami, aż po przygody off-road. Odkryj świat pełen adrenalinowych doświadczeń na Go-Racing.pl i poczuj prawdziwą pasję motoryzacji!' },
    { name: 'keywords', content: 'prezent, jazda, samochód, off-road, 4x4, bolid f1, szkolenia, voucher, podarunek' },
    { name: 'robots', content: 'index,follow' }
  ],
  link: [
    { rel: 'canonical', href: runtimeConfig.public.baseUrl }
  ]
})
</script>

<template>
  <BannersBannerMap :use-video="true" />
  <div class="container mx-auto">
    <BannersCategory class="mt-[30px]" />
    <div class="text-24 lg:text-30 font-medium py-[25px]">
      Popularne kategorie
    </div>
    <BannersBanner class="flex flex-col md:flex-row justify-between items-center gap-[20px]" />
    <div class="bg-[url('/voucher.jpg')] bg-center mt-[30px] p-[15px] flex flex-col md:flex-row md:items-center md:justify-between">
      <div class="flex flex-col w-full">
        <div class="text-24 lg:text-30 font-medium mb-[15px]">
          Karta podarunkowa
        </div>
        <div class="text-12 font-medium">
          Szukasz pomysłu na prezent?
        </div>
        <div class="text-12 font-medium mb-[15px]">
          Wybierz kartę podarunkową Go Racing i podaruj bliskim niezapomnianą jazdę pełną emocji!
        </div>
      </div>
      <div class="w-full md:w-80 xl:mr-28">
        <NuxtLink to="/p/karta-podarunkowa-go-racing-200-zl" class="btn btn-primary mt-4 md:mt-0">
          <span>Sprawdź</span>
        </NuxtLink>
      </div>
    </div>
    <Recommended :products="recommended2.elements" name="Bestsellery" url="/k/bestsellery" :mobile="mobile" :limit="4" />
    <Recommended :products="recommended3.elements" name="Promocje" url="/k/promocje" :mobile="mobile" :limit="4" />
    <RecommendedRows :products="recommended1.elements" name="Polecane produkty" url="/k/oferta" :mobile="mobile" :limit="6" />
    <div v-html="html" class="format-html mb-[50px]" />
  </div>
</template>
